/** GraphQL selection for reservation source parent dropdowns (the fields any signed-in user may read). */
export const RESERVATION_SOURCE_PARENT_DROPDOWN_QUERY = `
  id
  name
  code
  enabled
`;
